import {
  createRootRoute, createRoute, createRouter, Outlet, createMemoryHistory,
} from "@tanstack/react-router";
import { Shell } from "../shell/Shell.js";
import { Painel } from "../telas/Painel.js";
import { QuadroDePessoas } from "../telas/QuadroDePessoas.js";
import { Configuracoes } from "../telas/Configuracoes.js";
import { Admissao } from "../telas/Admissao.js";
import { Espelho } from "../telas/Espelho.js";
import { BancoDeHoras } from "../telas/BancoDeHoras.js";
import { Fechamento } from "../telas/Fechamento.js";
import { Rubricas } from "../telas/Rubricas.js";
import { Ferias } from "../telas/Ferias.js";
import { Equipe } from "../telas/Equipe.js";
import {
  Afastamentos, Exames, Epi, Acidentes, Beneficios, Faturas,
  ESocialPainel, Desempenho,
} from "../telas/Operacao.js";
import { Rescisao } from "../telas/Rescisao.js";
import {
  Clima, Psicossocial, Treinamento, Relatorios, ArquivosFiscais,
} from "../telas/Gestao.js";
import { Ponto } from "../telas/Ponto.js";
import { Folha } from "../telas/Folha.js";
import { ESocial } from "../telas/ESocial.js";
import { Conta, TrocarSenha, Ajuda } from "../telas/Conta.js";
import { Equipamentos } from "../telas/Equipamentos.js";
import { Atividade, PoliticaMonitoramento } from "../telas/Atividade.js";
import { EmptyState } from "@pessoas/ui";
import { Pagina } from "../shell/Pagina.js";

const raiz = createRootRoute({
  component: () => <Shell><Outlet /></Shell>,
  notFoundComponent: () => (
    <Pagina titulo="Página não encontrada">
      <EmptyState
        titulo="Esta tela não existe"
        descricao="Confira o endereço ou volte pelo menu à esquerda."
      />
    </Pagina>
  ),
});

/** Tela ainda não construída aparece NOMEADA, em vez de rota morta. */
const emConstrucao = (titulo: string, descricao: string) => () => (
  <Pagina titulo={titulo} descricao={descricao}>
    <EmptyState
      titulo="Em construção"
      descricao="Esta tela entra na próxima onda. O motor por trás dela já está pronto e testado."
      tom="atencao"
    />
  </Pagina>
);

const rota = (path: string, component: () => React.JSX.Element) =>
  createRoute({ getParentRoute: () => raiz, path, component });

const rotas = [
  rota("/", Painel),
  rota("/pessoas", QuadroDePessoas),
  rota("/admissao", Admissao),
  rota("/afastamentos", Afastamentos),
  rota("/ponto", Ponto),
  rota("/ponto/espelho", Espelho),
  rota("/ponto/banco-de-horas", BancoDeHoras),
  rota("/folha", Fechamento),
  rota("/folha/rubricas", Rubricas),
  rota("/folha/ferias", Ferias),
  rota("/folha/rescisao", Rescisao),
  rota("/atividade", Atividade),
  rota("/atividade/politica", PoliticaMonitoramento),
  rota("/equipamentos", Equipamentos),
  rota("/esocial", ESocialPainel),
  rota("/esocial/arquivos", ArquivosFiscais),
  rota("/beneficios", Beneficios),
  rota("/beneficios/faturas", Faturas),
  rota("/sst/exames", Exames),
  rota("/sst/epi", Epi),
  rota("/sst/acidentes", Acidentes),
  rota("/sst/psicossocial", Psicossocial),
  rota("/desempenho", Desempenho),
  rota("/clima", Clima),
  rota("/treinamento", Treinamento),
  rota("/relatorios", Relatorios),
  rota("/configuracoes", Configuracoes),
  rota("/configuracoes/equipe", Equipe),

  // Conta: são as telas que o menu do usuário abre. Sem elas, o menu leva a 404.
  rota("/conta", Conta),
  rota("/conta/senha", TrocarSenha),
  rota("/ajuda", Ajuda),
];

export const arvore = raiz.addChildren(rotas);

export const criarRouter = (opcoes: { memoria?: string[] } = {}) =>
  createRouter({
    routeTree: arvore,
    ...(opcoes.memoria
      ? { history: createMemoryHistory({ initialEntries: opcoes.memoria }) }
      : {}),
    defaultPreload: "intent",
  });

export const router = criarRouter();

declare module "@tanstack/react-router" {
  interface Register { router: typeof router }
}
